import type { ItineraryBlock } from '@/types/itinerary';

export function filterItineraryBlocksByType(itineraryBlocks: ItineraryBlock[], type: ItineraryBlock['type']) {
  return itineraryBlocks.filter((block) => block.type === type);
}
